import React from 'react';

//Estilos
import './NewDJDUV.css';
import TableContainer from '../../components/table/TableContainer';

function NewDJDUV({ functions, states }) {
    const { tableData, DJTVData } = states;

    const { handleSubmit, onSubmit } = functions;

    return (
        <div className="newDJDUV-container">
            <form className="newDJDUV-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de División/Unificación de Viñedo ${DJTVData?.cabecera?.serie}-P-${DJTVData?.cabecera?.numero}${DJTVData?.cabecera?.viniedo}`}
                </h4>
                <TableContainer tableData={tableData} />
                <div className="newDJDUV-footer">
                    <button
                        type="submit"
                        className="btn btn-primary btn-submit-newDJDUV"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewDJDUV;
